import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import WakePortal from 'containers/WakePortal';
import { getUserDetails } from 'components/../redux/actions/auth';
import { isWakeOnlyUser } from 'utils/permissionHelpers';

// The Wake Portal hangs off the admin console but deliberately renders without
// MainLayout, so it has no sidebar, header or breadcrumbs - the only way in or out
// is the browser's own back/forward navigation.
export const WakePortalRoute = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { userInfo, userToken } = useSelector((state) => state.auth);

    useEffect(() => {
        if (userToken) {
            dispatch(getUserDetails());
        }
    }, [dispatch, userToken]);

    if (!userInfo) {
        return <Navigate to={{ pathname: '/login' }} state={{ from: location }} />;
    }

    // Only /api/auth/user/ carries is_on_prem, so until that answers we cannot tell
    // a portal user from an admin. Deciding early would bounce a legitimate portal
    // user to /home, and PrivateRoute would bounce them straight back.
    if (Object.prototype.hasOwnProperty.call(userInfo, 'is_on_prem') === false) {
        return null;
    }

    // Reaching this URL is not enough - anyone who belongs in the admin console is
    // sent there instead of being shown the portal.
    if (isWakeOnlyUser(userInfo) === false) {
        return <Navigate to="/home" replace />;
    }
    // The org name and the identity the wake is requested for both come from
    // /api/auth/user/, so wait for it before painting the page.
    if (!userInfo.user) {
        return null;
    }

    return <WakePortal />;
};

export default WakePortalRoute;
